import React from 'react';
import { Container } from '../components/Container';
import { Shirt, Palette, Clock, FileText, Package, Phone, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const STARTING_PATHS = [{
  icon: Shirt,
  title: 'Product Sample Deposit',
  desc: 'Want to see and feel the quality first? Place a fully refundable deposit to get physical samples sent to you.',
  action: 'Request Samples',
  popular: false
}, {
  icon: Palette,
  title: 'Art Deposit',
  desc: 'Ready to start designing? Place a small deposit to have our art team begin working on your custom mockups.',
  action: 'Start Design',
  popular: true
}, {
  icon: Clock,
  title: 'Early Bird Deposit',
  desc: 'Planning ahead? Lock in your pricing and production spot for the upcoming season with an early deposit.',
  action: 'Lock in Pricing',
  popular: false
}, {
  icon: FileText,
  title: 'Send a Quote',
  desc: 'Already have a quote from another company? Send it to us and we guarantee to beat their pricing.',
  action: 'Upload Quote',
  popular: false
}, {
  icon: Package,
  title: 'Start with a Team Package',
  desc: 'Need a full bundle of uniforms, warm-ups, and bags? Browse our package options to get started.',
  action: 'View Packages',
  popular: false
}, {
  icon: Phone,
  title: 'Call or Fill Out Form',
  desc: 'Not sure where to start? Give us a call or fill out the form below and a team member will guide you.',
  action: 'Contact Us',
  popular: false
}];
export function GetStarted() {
  return <div className="w-full bg-gray-50 min-h-screen pb-20" data-id="element-447">
      {/* Header */}
      <div className="bg-[#111827] text-white py-16" data-id="element-448">
        <Container data-id="element-449">
          <div className="max-w-3xl" data-id="element-450">
            <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-451">
              Let's Get Started
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-452"></div>
            <p className="text-xl text-gray-300" data-id="element-453">
              Choose the path that best fits where you are in the ordering
              process. We're here to help every step of the way.
            </p>
          </div>
        </Container>
      </div>

      <Container className="-mt-8" data-id="element-454">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-455">
          {STARTING_PATHS.map((path, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-white rounded-xl shadow-md border-2 overflow-hidden flex flex-col ${path.popular ? 'border-pts-red relative' : 'border-transparent'}`} data-id="element-456">
              {path.popular && <div className="bg-pts-red text-white text-xs font-bold uppercase tracking-wider py-1 text-center" data-id="element-457">
                  Most Popular Starting Point
                </div>}
              <div className="p-8 flex-grow flex flex-col" data-id="element-458">
                <div className="w-14 h-14 bg-gray-100 text-gray-900 rounded-lg flex items-center justify-center mb-6" data-id="element-459">
                  <path.icon className="h-7 w-7" data-id="element-460" />
                </div>
                <h3 className="font-oswald text-2xl font-bold text-gray-900 uppercase mb-3" data-id="element-461">
                  {path.title}
                </h3>
                <p className="text-gray-600 mb-8 flex-grow" data-id="element-462">{path.desc}</p>
                <button className="w-full flex items-center justify-center bg-gray-900 hover:bg-pts-red text-white px-6 py-3 rounded font-bold uppercase tracking-wide text-sm transition-colors group" data-id="element-463">
                  {path.action}
                  <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-464" />
                </button>
              </div>
            </motion.div>)}
        </div>

        {/* Contact Form Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden max-w-4xl mx-auto" data-id="element-465">
          <div className="grid grid-cols-1 md:grid-cols-5" data-id="element-466">
            <div className="md:col-span-2 bg-[#111827] text-white p-8 md:p-10" data-id="element-467">
              <h3 className="font-oswald text-3xl font-bold uppercase mb-4" data-id="element-468">
                Tell Us What You Need
              </h3>
              <p className="text-gray-300 mb-8" data-id="element-469">
                Fill out this quick form and a team specialist will get back to
                you within 24 hours.
              </p>

              <div className="space-y-6" data-id="element-470">
                <div data-id="element-471">
                  <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-472">
                    Direct Line
                  </h4>
                  <a href="tel:8882188647" className="text-xl font-bold hover:text-pts-red transition-colors" data-id="element-473">
                    888.218.8647
                  </a>
                </div>
                <div data-id="element-474">
                  <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-475">
                    Email
                  </h4>
                  <a href="mailto:savemoney@getcustomuniforms.com" className="text-lg hover:text-pts-red transition-colors" data-id="element-476">
                    savemoney@getcustomuniforms.com
                  </a>
                </div>
              </div>
            </div>

            <div className="md:col-span-3 p-8 md:p-10" data-id="element-477">
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-478">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-479">
                  <div data-id="element-480">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-481">
                      First Name
                    </label>
                    <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-482" />
                  </div>
                  <div data-id="element-483">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-484">
                      Last Name
                    </label>
                    <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-485" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-486">
                  <div data-id="element-487">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-488">
                      Email Address
                    </label>
                    <input type="email" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-489" />
                  </div>
                  <div data-id="element-490">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-491">
                      Phone Number
                    </label>
                    <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-492" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-493">
                  <div data-id="element-494">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-495">
                      Organization / Team Name
                    </label>
                    <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-496" />
                  </div>
                  <div data-id="element-497">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-498">
                      Sport
                    </label>
                    <select className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-499">
                      <option data-id="element-500">Select a Sport</option>
                      <option data-id="element-501">Baseball</option>
                      <option data-id="element-502">Basketball</option>
                      <option data-id="element-503">Football</option>
                      <option data-id="element-504">Softball</option>
                      <option data-id="element-505">Soccer</option>
                      <option data-id="element-506">Cheer</option>
                      <option data-id="element-507">Volleyball</option>
                      <option data-id="element-508">Track & Field</option>
                      <option data-id="element-509">Other / Groupwear</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-510">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-511">
                    How can we help? (Optional)
                  </label>
                  <textarea rows={4} className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-pts-red focus:border-pts-red outline-none resize-none" placeholder="Tell us about your team's needs, timeline, or if you have a quote to beat..." data-id="element-512"></textarea>
                </div>

                <div className="pt-2" data-id="element-513">
                  <button type="submit" className="w-full bg-pts-red hover:bg-pts-red-dark text-white px-6 py-3 rounded font-bold uppercase tracking-wide transition-colors" data-id="element-514">
                    Submit Request
                  </button>
                  <p className="text-xs text-gray-500 text-center mt-3" data-id="element-515">
                    Have a quote to attach? You can email it directly to
                    savemoney@getcustomuniforms.com
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>;
}